var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.42989 15.97C2.25375 16.0392 2.05276 15.9815 1.93533 15.8293C1.77048 15.6148 1.83371 15.3011 2.06857 15.1697C2.52022 14.9183 3.30836 14.4339 4.07842 13.7973C5.62759 12.5195 6.06795 10.536 3.90905 9.6941C1.54239 8.77151 0 6.95632 0 4.82514C0 2.16116 2.36892 0 4.97721 0C7.42517 0 9.47793 2.06429 9.71505 4.49993C9.71505 4.49993 9.83022 4.82283 9.85958 6.06372C9.92958 8.92374 9.03305 13.3822 2.42763 15.97H2.42989Z",
    fill: "#E43C5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.0f31fb9bf0119cbbeb9259dc05c62625.svg";
export { ForwardRef as ReactComponent };